import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { DateSelect } from '../../../compnents/form/DateSelect'
import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'
import { RootDispatch } from '../../../app/store'
const { Option } = Select

export const Query = (props: {
  onValueChange: (queries: any) => void
  export: () => void
  exportLoading?: any
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(vs) => {
        props.onValueChange({
          current: 1,
          ...vs,
          timeHead: null,
          timeTail: null,
          startTime: vs?.timeHead
            ? moment(vs?.timeHead).format(DateTimeFormatSimpleOnlyOne)
            : null,
          endTime: vs?.timeTail
            ? moment(vs?.timeTail).format(DateTimeFormatSimpleOnlyOne)
            : null,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%', height: '42px' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='companyName' noStyle>
            <Input
              size='middle'
              placeholder='企业名称'
              allowClear
              onChange={form.submit}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='acceptStatus' noStyle>
            <Select
              placeholder='首营审核状态'
              style={{ width: 150 }}
              allowClear
              onChange={form.submit}
            >
              <Option key={'0'} value={'0'}>
                全部
              </Option>
              <Option key={'-1'} value={'-1'}>
                未审核
              </Option>
              <Option key={'2'} value={'2'}>
                部分审核
              </Option>
              <Option key={'1'} value={'1'}>
                全部已审核
              </Option>
            </Select>
          </Form.Item>
          <Form.Item name='' noStyle>
            <DateSelect
              placeholder='时间范围'
              style={{ width: '11rem' }}
              onChange={form.submit}
              // initialValue={DateRangeType.Today}
              labelPrefix=''
              namePrefix='time'
              allowClear={true}
            />
          </Form.Item>
          <Button
            onClick={form.submit}
            type='primary'
            style={{ float: 'right' }}
          >
            查询
          </Button>
        </Space>
        <Space>
          <Button
            loading={props?.exportLoading}
            onClick={() => {
              props?.export && props?.export()
            }}
            type='primary'
          >
            导出
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
